import { render, staticRenderFns } from "./StoreOrders.vue?vue&type=template&id=f334f7d6"
import script from "./StoreOrders.vue?vue&type=script&lang=js"
export * from "./StoreOrders.vue?vue&type=script&lang=js"
import style0 from "./StoreOrders.vue?vue&type=style&index=0&id=f334f7d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports